import { render } from "./DetalleCitasPorEstado.vue?vue&type=template&id=20aa4898&scoped=true"
import script from "./DetalleCitasPorEstado.vue?vue&type=script&lang=js"
export * from "./DetalleCitasPorEstado.vue?vue&type=script&lang=js"

import "./DetalleCitasPorEstado.vue?vue&type=style&index=0&id=20aa4898&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20aa4898"]])

export default __exports__